import { render, staticRenderFns } from "./CreateLead.vue?vue&type=template&id=12b3b448&scoped=true&"
import script from "./CreateLead.vue?vue&type=script&lang=js&"
export * from "./CreateLead.vue?vue&type=script&lang=js&"
import style0 from "./CreateLead.vue?vue&type=style&index=0&id=12b3b448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3b448",
  null
  
)

export default component.exports